import bmApiService from '@/services/bmApi';
import { selectCompany } from '@/store/reducers/company';
import type { ApplicationState } from '@/store';

export const NEW_EMBED_FLAG_NAME = 'new-embed';

export interface FeatureFlagState {
    enabled: boolean;
    isLoading: boolean;
}

const FLAGS_NOT_LOADED: FeatureFlagState = { enabled: false, isLoading: true };

export const selectFeatureFlagsQueryArg = (state: ApplicationState): { CompanyId: string } | undefined => {
    const companyId = selectCompany(state)?.Id;
    return companyId ? { CompanyId: companyId } : undefined;
};

export const selectFeatureFlag = (flagName: string) => (state: ApplicationState): FeatureFlagState => {
    const queryArg = selectFeatureFlagsQueryArg(state);
    if (!queryArg) return FLAGS_NOT_LOADED;
    const result = bmApiService.endpoints.getCompanyFeatureFlags.select(queryArg)(state);
    const isLoading = result.isUninitialized || result.isLoading;
    const enabled = !!result.data?.some((flag) => flag.Name === flagName && flag.IsEnabled);
    return { enabled, isLoading };
};

export const selectNewEmbedFlag = selectFeatureFlag(NEW_EMBED_FLAG_NAME);
